/**
 * Description: 校验数字的正则表达式
 * @author: lhc
 * @date: 2022/1/10 14:27
 */

const NumRegExp = {
  /*  0 数字                          */ _N_0: `^[0-9]*$`,
  /*  1 n位的数字                     */ _N_1: `^\\d{n}$`,
  /*  2 至少n位的数字                 */ _N_2: `^\\d{n,}$`,
  /*  3 m-n位的数字                   */ _N_3: `^\\d{m,n}$`,
  /*  4 零和非零开头的数字            */ _N_4: `^(0|[1-9][0-9]*)$`,
  /*  5 非零开头的最多带两位小数的数字*/ _N_5: `^([1-9][0-9]*)+(\\.[0-9]{1,2})?$`,
  /*  6 带1-2位小数的正数或负数       */ _N_6: `^(\\-)?\\d+(\\.\\d{1,2})$`,
  /*  7 正数、负数、和小数            */ _N_7: `^(\\-|\\+)?\\d+(\\.\\d+)?$`,
  /*  8 有两位小数的正实数            */ _N_8: `^[0-9]+(\\.[0-9]{2})?$`,
  /*  9 有1~3位小数的正实数           */ _N_9: `^[0-9]+(\\.[0-9]{1,3})?$`,
  /* 10 非零的正整数                  */ _N_10: `^[1-9]\\d*$`,            // ^([1-9][0-9]*){1,3}$/ 或 ^\+?[1-9][0-9]*$/
  /* 11 非零的负整数                  */ _N_11: `^-[1-9]\\d*$`,
  /* 12 非负整数                      */ _N_12: `^\\d+$`,                 // ^[1-9]\\d*|0$/
  /* 13 非正整数                      */ _N_13: `^-[1-9]\\d*|0$`, // ^((-\\d+)|(0+))$/
  /* 14 非负浮点数                    */ _N_14: `^\\d+(\\.\\d+)?$`, // ^[1-9]\\d*\\.\\d*|0\\.\\d*[1-9]\\d*|0?\\.0+|0$/
  /* 15 非正浮点数                    */ _N_15: `^((-\\d+(\\.\\d+)?)|(0+(\\.0+)?))$`, // ^(-([1-9]\\d*\\.\\d*|0\\.\\d*[1-9]\\d*))|0?\\.0+|0$/
  /* 16 正浮点数                      */ _N_16: `^[1-9]\\d*\\.\\d*|0\\.\\d*[1-9]\\d*$`,  //^(([0-9]+\\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\\.[0-9]+)|([0-9]*[1-9][0-9]*))$/
  /* 17 负浮点数                      */ _N_17: `^-([1-9]\\d*\\.\\d*|0\\.\\d*[1-9]\\d*)$`, // ^(-(([0-9]+\\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
  /* 18 浮点数                        */ _N_18: `^(-?\\d+)(\\.\\d+)?$`, // ^-?([1-9]\\d*\\.\\d*|0\\.\\d*[1-9]\\d*|0?\\.0+|0)$/
}

export default NumRegExp
